import React from 'react'
import { Link } from 'react-router-dom'

import AiAssistantPage, { CheckList, Steps, Section } from './ai-assistant-page'

const ChatGPTIntegration = () => (
  <AiAssistantPage
    slug="chatgpt"
    name="ChatGPT"
    badge="ChatGPT Plugin"
    title="ChatGPT SMS Connector | DataFlows"
    description="Send, schedule and track business SMS from your DataFlows account by asking ChatGPT in plain language. The DataFlows SMS plugin works in ChatGPT and Codex."
    heading="DataFlows SMS for ChatGPT"
    intro="Send, schedule and track business SMS from your DataFlows account by asking ChatGPT in plain language. The DataFlows SMS plugin works in ChatGPT and Codex."
    disconnect="In ChatGPT, open Plugins, select DataFlows SMS and disconnect the account. Disconnecting stops access straight away."
    relatedLink={<Link to="/integrations/claude" className="cliniko-related-link">Claude SMS</Link>}
  >
    <Section label="Requirements" title="What you need">
      <CheckList items={[
        'A DataFlows account with SMS credits',
        'A sender ID or number on your account (your default sender is used unless you choose another)',
        'A ChatGPT account',
      ]} />
    </Section>

    <Section label="Setup" title="Connect in ChatGPT" id="connect" dark>
      <Steps items={[
        'In ChatGPT, open Plugins and search for DataFlows SMS.',
        'Select DataFlows SMS, then Connect.',
        'Sign in with your DataFlows login and select Allow Access.',
        'Ask ChatGPT to use DataFlows SMS in any chat.',
      ]} />
    </Section>
  </AiAssistantPage>
)

export default ChatGPTIntegration
